// Author YuJiaBei
// Date 2021-07-18 10:45:03

import * as model from "@/model/em/opcClient/EmOpcUaNodeSubscriptionEounsModel.js";
import {newEntityStoreHelper} from "@/store/common/entityModule";

function newFilter(paginationFilter = {}) {
    var filter = Object.assign({}, paginationFilter, model.filter)
    return filter;
}

export default newEntityStoreHelper(() => new model.EmOpcUaNodeSubscriptionEouns(),newFilter)
    .withStates({
        baseModuleUrl: process.env.VUE_APP_EM_OPCCLIENT_URL,
    })
    .buildStore()
